import { MoreVertical } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

interface CardOverflowMenuProps {
  onEdit: () => void
  onDelete: () => void
}

export function CardOverflowMenu({ onEdit, onDelete }: CardOverflowMenuProps): JSX.Element {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open])

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="rounded-full p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        aria-label="More actions"
        type="button"
      >
        <MoreVertical size={16} />
      </button>

      {open && (
        <div className="absolute right-0 z-20 mt-1 w-36 rounded-lg border border-gray-200 bg-white py-1 shadow-lg">
          <button
            onClick={() => { setOpen(false); onEdit() }}
            className="flex w-full items-center px-3 py-2 text-left text-[13px] text-gray-700 hover:bg-gray-50"
            type="button"
          >
            Edit
          </button>
          <button
            onClick={() => { setOpen(false); onDelete() }}
            className="flex w-full items-center px-3 py-2 text-left text-[13px] text-red-600 hover:bg-red-50"
            type="button"
          >
            Delete
          </button>
        </div>
      )}
    </div>
  )
}
